import React from 'react'

import ConfigLoader from './_load/ConfigLoader'
import ControlledModal from '../../../../components/modals/ControlledModal'
import EditConfigForm from './EditConfigForm'
import Line from '../../../../packages/kiti/components/helpers/Line'
import ModalHeader from './ModalHeader'
import Separator from '../../../../components/helpers/Separator'

const EditServiceOrderAutomaticDistributionConfigModal = props => {
  return (
    <ControlledModal width="32rem" {...props}>
      <ConfigLoader>
        <ModalHeader />

        <EditConfigForm />
      </ConfigLoader>
    </ControlledModal>
  )
}

export default EditServiceOrderAutomaticDistributionConfigModal
